import { SubSpecialty } from "./sub-specialty.model";

export class Expert {
	id: string;
	user_id?: string = '';
	first_name?: string = '';
	last_name?: string = '';
	email?: string = '';
	is_setup?: boolean = false;
	date_of_birth?: string = '';
	phone?: string = '';
	full_address?: string = '';
	timezone?: any;
	bio?: string = '';
	degree?: string = '';
	degree_year?: string = '';
	med_school?: string = '';
	languages?: string = '';
	affiliation?: string = '';
	hospital_affiliations?: string = '';
	social?: string = '';
	specialty?: string = '';
	sub_specialty?: string = '';
	malpractice_carrier_date?: string = '';
	malpractice_carrier?: string = '';
	professional_license_date?: string = '';
	professional_license?: string = '';
	fellowship_year?: string = '';
	npi_number?: string = '';
	fellowship_location?: string = '';
	fellowship_type?: string = '';
	fellowship?: string = '';
	residency_year?: string = '';
	residency_location?: string = '';
	residency_type?: string = '';
	session_invites_sent?: string = '';
	residency?: string = '';
	med_school_year?: string = '';
	postal_code?: string = '';
	state?: string = '';
	city?: string = '';
	country?: string = '';
	zoom_id?: string = '';
	status?: string = '';
	profile_image?: string = '';
	created_at?: Number = null;
	updated_at?: Number = null;
	invited_on?: Number;
	specialty_list?: SubSpecialty[];
	quiet_hours_on: boolean = true;   
}

export class ExpertStatus {
	static INVITED = 'invited';
	static ACTIVE = 'active';
	static DISABLED = 'disabled';
	static TERMINATED = 'terminated';
	static PENDING = 'pending';
	static INCOMPLETE = 'incomplete';
}